














import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Dialog from '@/store/modules/dialog';
import store from '@/store/store';

const dialogModule = getModule(Dialog, store);

@Component
export default class TutorialDialog extends Vue {
  images = [
    require('@/assets/images/tutorial/02_login.png'),
    require('@/assets/images/tutorial/03_login.png'),
    require('@/assets/images/tutorial/04_image.png'),
    require('@/assets/images/tutorial/05_image.png'),
    require('@/assets/images/tutorial/06_image.png'),
    require('@/assets/images/tutorial/07_image.png'),
    require('@/assets/images/tutorial/08_transcribe.png'),
    require('@/assets/images/tutorial/09_transcribe.png'),
    require('@/assets/images/tutorial/10_transcribe.png'),
    require('@/assets/images/tutorial/11_transcribe.png'),
    require('@/assets/images/tutorial/12_review.png'),
    require('@/assets/images/tutorial/13_ai.png'),
    require('@/assets/images/tutorial/14_ai.png'),
  ];

  get show() {
    return dialogModule.tutorialDialog;
  }

  set show(value) {
    dialogModule.toggleTutorialDialog({ open: value });
  }
}
